import { render, staticRenderFns } from "./privecypolicy.vue?vue&type=template&id=75ebdf9e&"
import script from "./privecypolicy.vue?vue&type=script&lang=js&"
export * from "./privecypolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports